type BrandLogoProps = {
  size?: number
  className?: string
  /** Prefer larger source for big marks (login/register). */
  src?:
    | '/icon-64.png'
    | '/icon-64x64.png'
    | '/icon-128.png'
    | '/icon-128x128.png'
    | '/icon-256.png'
    | '/icon-256x256.png'
    | '/icon-512.png'
    | '/android-chrome-192x192.png'
    | '/android-chrome-512x512.png'
    | '/context-harbor-master-1024.png'
}

export default function BrandLogo({
  size = 40,
  className = '',
  src = '/icon-64.png',
}: BrandLogoProps) {
  return (
    <img
      src={src}
      alt="ContextHarbor"
      width={size}
      height={size}
      className={`rounded-[18%] object-cover shrink-0 overflow-hidden ${className}`}
      decoding="async"
    />
  )
}
